export default __webpack_public_path__ + "static/media/TotemManual20.a3de8344.jpg";